import PageSection from "@components/PageSection";
import React from "react";

interface IProps {
  itemsFrag: Queries.ItemsFragment;
}

interface itemrows {
  rowKey: string;
  productName?: string;
  sizeDescription?: string;
  gac_item_number?: string;
  upc?: string;
}

const Items = ({ itemsFrag }: IProps) => {
  if (!itemsFrag || !(itemsFrag.item_parents.length > 0)) return null;

  const { item_parents } = itemsFrag;

  const tableRows = item_parents.flatMap((ip) => {
    const subrows: itemrows[] = [];

    if (item_parents.length > 1) {
      subrows.push({ productName: ip.description ?? "", rowKey: `ProductNameRow ${ip?.description ?? ""}` });
    }

    const items = [...ip.items]
      .sort((a, b) => a.gac_item_number.localeCompare(b.gac_item_number))
      .map((i) => ({
        rowKey: `SizeRow: ${ip?.description ?? ""}  ${i?.size?.description ?? ""}`,
        sizeDescription: (i?.size?.description ?? ""),
        gac_item_number: i.gac_item_number,
        upc: i.upc,
      }));

    subrows.push(...items);
    return subrows;
  });

  return (
    <PageSection sectionName="Available Sizes">
      <table style={{ fontSize: "0.9rem" }}>
        <thead>
          <tr>
            <th align="left">Size</th>
            <th align="left">Item</th>
            <th align="left">UPC</th>
          </tr>
        </thead>
        <tbody>
          {tableRows.map((r) =>
            r.productName ? (
              <tr key={r.rowKey}>
                <td colSpan={3} style={{ background: "#AAAAAA", padding: "0.25rem" }}>
                  {r.productName}
                </td>
              </tr>
            ) : (
              <tr key={r.rowKey}>
                <td width={175}>{r?.sizeDescription ?? ""}</td>
                <td>{r?.gac_item_number ?? null}</td>
                <td>{r?.upc ?? null}</td>
              </tr>
            ),
          )}
        </tbody>
      </table>
    </PageSection>
  );
};

export default Items;
